function h(n) {
  if (n.sheet)
    return n.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === n)
      return document.styleSheets[t];
}
function l(n) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", n.key), n.nonce !== void 0 && t.setAttribute("nonce", n.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var d = /* @__PURE__ */ function() {
  function n(r) {
    var e = this;
    this._insertTag = function(i) {
      var s;
      e.tags.length === 0 ? e.insertionPoint ? s = e.insertionPoint.nextSibling : e.prepend ? s = e.container.firstChild : s = e.before : s = e.tags[e.tags.length - 1].nextSibling, e.container.insertBefore(i, s), e.tags.push(i);
    }, this.isSpeedy = r.speedy === void 0 ? process.env.NODE_ENV === "production" : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = n.prototype;
  return t.hydrate = function(e) {
    e.forEach(this._insertTag);
  }, t.insert = function(e) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(l(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = e.charCodeAt(0) === 64 && e.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var o = h(i);
      try {
        o.insertRule(e, o.cssRules.length);
      } catch (a) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(e) && console.error('There was a problem inserting the following rule: "' + e + '"', a);
      }
    } else
      i.appendChild(document.createTextNode(e));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(e) {
      return e.parentNode && e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, n;
}();
export {
  d as StyleSheet
};
//# sourceMappingURL=emotion-sheet.browser.esm.js.map
